$(document).ready(function(){

	var itemWidth = $('.dinamics .block .block-items .item');
	var cw = $('.dinamics .block .block-items .item').width();

	if ($(window).width() > 991) {
		var itemWidth = $('.dinamics .block .block-items .item');
		$(itemWidth).css({'height':cw+'px'});
		window.addEventListener('resize',function(){
		    // alert('Размеры окна изменились');
			var cw = $('.dinamics .block .block-items .item').width();
			$(itemWidth).css({'height':cw+'px'});
		});
	} 

	var itemWidthGallery = $('.dinamics-gallery .block .block-items .item');
	var cwGallery = $('.dinamics-gallery .block .block-items .item').width();

	// if ($(window).width() > 991) {
		var itemWidthGallery = $('.dinamics-gallery .block .block-items .item');
		$(itemWidthGallery).css({'height':cwGallery+'px'});
		window.addEventListener('resize',function(){
		    // alert('Размеры окна изменились');
			var cwGallery = $('.dinamics-gallery .block .block-items .item').width();
			$(itemWidthGallery).css({'height':cwGallery+'px'});
		});
	// } 



	var itemWidthGallery = $('.coast .block .check-block .img-wrapper');
	var cwGallery = $('.coast .block .check-block .img-wrapper').width();

	// if ($(window).width() > 991) {
		var itemWidthGallery = $('.coast .block .check-block .img-wrapper');
		$(itemWidthGallery).css({'height':cwGallery+'px'});
		window.addEventListener('resize',function(){
		    // alert('Размеры окна изменились');
			var cwGallery = $('.coast .block .check-block .img-wrapper').width();
			$(itemWidthGallery).css({'height':cwGallery+'px'});
		});
	// } 
});